// import { cn } from "@/lib/utils";
// import { RenderElementProps } from "slate-react";

// // Image element structure as expected by Plate
// export interface TImageElement {
//   type: "image";
//   url: string;
//   alt?: string;
//   caption?: string;
//   className?: string;
//   children: [{ text: string }];
// }

// /**
//  * Component for rendering image elements in the Plate editor.
//  * Follows the exact Slate/Plate pattern for image rendering.
//  */
// export function ImageElement(props: RenderElementProps) {
//   const { attributes, children, element } = props;
//   const imageElement = element as TImageElement;

//   return (
//     <div>
//       <div contentEditable={false} data-slate-void>
//         <div className={cn("my-4 w-full", imageElement.className)}>
//           <figure className="relative w-full">
//             <img
//               src={imageElement.url}
//               alt={imageElement.alt || imageElement.caption || "Image"}
//               className="w-full h-auto rounded-md object-cover block mx-auto"
//               draggable={false}
//             />
//             {imageElement.caption && (
//               <figcaption className="text-sm text-gray-500 mt-2 text-center">
//                 {imageElement.caption}
//               </figcaption>
//             )}
//           </figure>
//         </div>
//       </div>
//       {children}
//     </div>
//   );
// }

import type { TImageElement } from "@udecode/plate-media";
import type { PlateElementProps } from "@udecode/plate/react";

import { useDraggable } from "@udecode/plate-dnd";
import { Image, ImagePlugin, useMediaState } from "@udecode/plate-media/react";
import { ResizableProvider, useResizableValue } from "@udecode/plate-resizable";
import { PlateElement, withHOC } from "@udecode/plate/react";

import { cn } from "@/lib/utils";

import { Caption, CaptionTextarea } from "./caption";
import { MediaPopover } from "./media-popover";
import {
  mediaResizeHandleVariants,
  Resizable,
  ResizeHandle,
} from "./resize-handle";

export const ImageElement = withHOC(
  ResizableProvider,
  function ImageElement(props: PlateElementProps<TImageElement>) {
    const { align = "center", focused, readOnly, selected } = useMediaState();
    const width = useResizableValue("width");

    const { isDragging, handleRef } = useDraggable({
      element: props.element,
    });

    return (
      <MediaPopover plugin={ImagePlugin}>
        <PlateElement {...props} className="py-2.5">
          <figure className="group relative m-0" contentEditable={false}>
            <Resizable
              align={align}
              options={{
                align,
                readOnly,
              }}
            >
              <ResizeHandle
                className={mediaResizeHandleVariants({ direction: "left" })}
                options={{ direction: "left" }}
              />
              <Image
                ref={handleRef}
                className={cn(
                  "block w-full max-w-full cursor-pointer object-cover px-0",
                  "rounded-sm",
                  focused && selected && "ring-2 ring-ring ring-offset-2",
                  isDragging && "opacity-50"
                )}
                alt={(props.attributes as any).alt}
              />
              <ResizeHandle
                className={mediaResizeHandleVariants({
                  direction: "right",
                })}
                options={{ direction: "right" }}
              />
            </Resizable>

            <Caption style={{ width }} align={align}>
              <CaptionTextarea
                readOnly={readOnly}
                onFocus={(e) => {
                  e.preventDefault();
                }}
                placeholder="Write a caption..."
              />
            </Caption>
          </figure>

          {props.children}
        </PlateElement>
      </MediaPopover>
    );
  }
);
